'use client';

import { useMount } from '../../hooks/useMount';
import { captureError } from '../../utils/errors';

import { InternalClientError } from '../display/internalClientError';
import { InternalServerError } from '../display/internalServerError';
import { NotAuthorized } from '../display/notAuthorized';

export function ErrorBoundaryFallback({ error }: { error?: any }) {
  useMount(() => {
    if (error) {
      captureError(error);
    }
  });

  if (error?.status === 401) {
    return <NotAuthorized returnTo="/" />;
  }

  if (error?.status === 500) {
    return <InternalServerError returnTo="/" />;
  }

  return <InternalClientError returnTo="/" />;
}
